exports.marketResearchAlertList = [
    {
      id: 1,
      icons: 'trendDetection',
      title: "Trend Detection",
      message:'New trend detected in customer preferences based on recent survey data',
      description:"A new trend has been detected in customer preferences, potentially impacting product/service demand and market positioning.",
      suggestion:"To capitalize on this trend, consider adjusting product features or marketing strategies to align with evolving customer preferences and stay ahead of competitors.",
      messgetime: "2 hours ago",
      messageStatus:'unreadstatus',
    }, 
    {
      id: 2,
      icons: 'emergingMarketSegment',
      title: "Emerging Market Segment",
      message:'Analysis reveals a new market segment with high growth potential. Targeting this segment can lead to strategic business expansion.',
      description: "Analysis has revealed a new market segment with high growth potential, but targeting strategies may not be optimized to capitalize on this opportunity.",
      suggestion:"Develop tailored marketing campaigns and product offerings specifically designed to resonate with the needs and preferences of this new segment, enabling strategic business expansion and market penetration.",
      messgetime: "12 hours ago",
      messageStatus:'unreadstatus',
    }, 
    {
      id: 3,
      icons: 'trendDetection',
      title: "Seasonal Trend Identification",
      message:' Seasonal trend influencing customer preferences has been identified. Adapting marketing strategies to capitalize on this trend can maximize revenue.',
      description: "A seasonal trend influencing customer preferences has been identified, but current marketing strategies may not be effectively leveraging this opportunity.",
      suggestion:"Adjust marketing campaigns and promotional efforts to align with seasonal trends, maximizing revenue potential by capitalizing on heightened customer interest and purchasing behavior during specific seasons or periods.",
      messgetime: "22 hours ago",
      messageStatus:'unreadstatus',
    },
    {
      id: 4,
      icons: 'segmentationShiftAlert',
      title: "Segmentation Shift Alert",
      message:'Customer segments have undergone significant changes.',
      description: "Customer segments have undergone significant changes, potentially rendering existing targeting strategies less effective.",
      suggestion:"Conduct a thorough analysis of the updated segmentation data to identify new opportunities for targeting and personalization. Adjust marketing strategies accordingly to ensure continued relevance and engagement with evolving customer segments.",
      messgetime: "21 hours ago",
      messageStatus:'readstatus',
    },
  ];

  exports.customerSatisfactionAlertList = [
    {
      id: 1,
      icons: 'low',
      title: "Low CSAT Score",
      message:'Customer satisfaction score falls below set benchmark.',
      description:"Customer satisfaction score has fallen below the set benchmark, indicating declining satisfaction levels.",
      suggestion:"Conduct a root cause analysis using customer feedback and CSAT survey data to identify pain points. Implement targeted improvements in product functionality, service processes, and customer support based on identified issues. Set up A/B testing for new changes to measure impact on satisfaction scores.",
      messgetime: "8 hours ago",
      messageStatus:'unreadstatus',
    },
    {
      id: 2,
      icons: 'low',
      title: "Negative Feedback",
      message:'Increase in negative feedback observed from recent surveys.',
      description: "Recent surveys indicate an increase in negative feedback, signaling potential issues that need attention.",
      suggestion:"Utilize text analytics and sentiment analysis tools to categorize and understand the negative feedback. Address common complaints by enhancing product features or improving service protocols. Develop a feedback loop to ensure continuous monitoring and timely resolution of new issues.",
      messgetime: "21 hours ago",
      messageStatus:'unreadstatus',
    },
    {
        id: 3,
        icons: 'response',
        title: "Response Rate Drop",
        message:'Response rates for CSAT surveys dropped significantly.',
        description: "Significant drop in response rates for CSAT surveys, impacting the reliability of satisfaction data.",
        suggestion:"Optimize survey distribution channels and timing based on customer behavior analytics. Simplify survey design for better user experience and consider integrating survey requests into high-engagement touchpoints such as post-purchase emails or app notifications. Use gamification or small incentives to encourage participation.",
        messgetime: "23 hours ago",
        messageStatus:'unreadstatus',
      },  
      {
        id: 4,
        icons: 'productquality',
        title: "Product Quality Concerns",
        message:'Increase in customer feedback expressing concerns about product quality. Investigating and rectifying quality issues is imperative to maintain customer trust.',
        description: "Increase in customer feedback expressing concerns about product quality, potentially affecting trust and satisfaction.",
        suggestion:"Perform a detailed quality assessment using product telemetry and defect tracking systems to identify and prioritize quality issues. Implement corrective actions using agile development methodologies. Communicate the improvements through customer newsletters or product update notes.",
        messgetime: "13 hours ago",
        messageStatus:'readstatus',
      },  
      {
        id: 5,
        icons: 'customerSupport',
        title: "Customer Support Performance Dip",
        message:'Customer satisfaction scores for support interactions have declined. Taking proactive measures to enhance support quality is recommended.',
        description: "Customer satisfaction scores for support interactions have declined, indicating potential service issues.",
        suggestion:"Deploy AI-driven analytics to evaluate support interaction logs and identify common issues or bottlenecks. Enhance support staff training programs with specific modules on identified weak areas. Implement real-time support quality monitoring tools to provide immediate feedback and corrective actions.",
        messgetime: "12 hours ago",
        messageStatus:'unreadstatus',
      },
      {
        id: 6,
        icons: 'featureRequest',
        title: "Feature Request Uptick",
        message:'Feature Request Uptick: Customers are requesting more of a particular product feature. Evaluating the feasibility of implementing these requests can enhance satisfaction.',
        description: "Customers are increasingly requesting more of a particular product feature, suggesting a gap in current offerings.",
        suggestion:"Integrate customer feature requests into the product development pipeline using a structured prioritization framework such as RICE (Reach, Impact, Confidence, Effort). Conduct feasibility analysis and rapid prototyping to assess potential feature implementations. Engage with a beta user group to test and gather feedback before a full-scale rollout.",
        messgetime: "12 hours ago",
        messageStatus:'readstatus',
      }, 
  ];

  exports.brandLoyaltyAlertList = [
    {
      id: 1,
      icons: 'positive',
      title: "Positive Sentiment",
      message:'Brand loyalty soars with surge in positive sentiment.',
      description:"Surge in positive sentiment detected, indicating increased brand loyalty.",
      suggestion:"Leverage this positive momentum by amplifying customer testimonials and success stories across marketing channels. Implement a referral program to encourage satisfied customers to advocate for the brand. Utilize sentiment analysis tools to identify key drivers of positive sentiment and reinforce these aspects in your offerings.",
      messgetime: "8 hours ago",
      messageStatus:'unreadstatus',
    },
    {
      id: 2,
      icons: 'brandAdvocacy',
      title: "Brand Advocacy",
      message:'Brand advocacy on the rise across social media channels.',
      description: "Rise in brand advocacy across social media channels, indicating strong customer engagement and loyalty.",
      suggestion:"Monitor social media mentions using social listening tools to identify and engage with brand advocates. Create a structured brand ambassador program to formalize advocacy efforts and provide exclusive incentives. Use analytics to measure the impact of advocacy on brand reach and sales, and adjust strategies to maximize benefits.",
      messgetime: "23 hours ago",
      messageStatus:'unreadstatus',
    }, 
    {
      id: 3,
      icons: 'negative',
      title: "Negative Brand Sentiment",
      message:'Increase in negative sentiment detected',
      description: "Increase in negative sentiment detected, posing a risk to brand loyalty and reputation.",
      suggestion:"Use sentiment analysis to pinpoint the sources of negative feedback and address specific issues promptly. Implement a crisis management plan to respond to widespread negative sentiment swiftly. Enhance product quality and customer service based on feedback to mitigate future negative experiences and improve overall sentiment.",
      messgetime: "10 hours ago",
      messageStatus:'readstatus',
    }, 
    {
      id: 4,
      icons: 'retentionRate',
      title: "Customer Retention Rate Decline",
      message:'Retention rates have decreased by 25%, suggesting challenges in maintaining brand loyalty.',
      description: "Retention rates have decreased by 25%, suggesting challenges in maintaining brand loyalty.",
      suggestion:"Review cohort analysis to identify the segments most affected by churn and understand their behavior. Implement targeted retention campaigns with personalized offers and incentives to re-engage these customers. Use predictive analytics to identify at-risk customers early and proactively address their concerns with tailored interventions.",
      messgetime: "12 hours ago",
      messageStatus:'readstatus',
    },  
    
  ];
  
  exports.NPSAlertList = [
    {
      id: 1,
      icons: 'detractor',
      title: "Detractor Increase",
      message:'Detractor responses spike in recent NPS feedback.',
      description:"There is a spike in detractor responses in recent NPS feedback, indicating growing customer dissatisfaction.",
      suggestion:"Perform a root cause analysis to identify common issues raised by detractors. Implement immediate corrective actions to address these pain points, such as improving product quality or customer service. Establish a feedback loop with detractors to demonstrate responsiveness and regain their trust.",
      messgetime: "15 hours ago",
      messageStatus:'unreadstatus',
    },
    {
      id: 2,
      icons: 'negative',
      title: "Promoter Decline",
      message:'Promoter responses decrease notably in recent NPS data.',
      description: "There is a notable decrease in promoter responses in recent NPS data, suggesting reduced customer enthusiasm and loyalty.",
      suggestion:"Conduct surveys and interviews with promoters who have become passive to understand their concerns. Enhance customer engagement programs and loyalty incentives to reignite enthusiasm. Revisit and improve key touchpoints in the customer journey to ensure a consistently excellent experience.",
      messgetime: "23 hours ago",
      messageStatus:'unreadstatus',
    }, 
    {
      id: 3,
      icons: 'detractor',
      title: "NPS Benchmark Shift",
      message:'Changes in NPS benchmark scores or industry standards have been observed.',
      description: "Changes in NPS benchmark scores or industry standards have been observed, potentially affecting competitive positioning.",
      suggestion:"Re-evaluate your NPS targets and performance relative to the new benchmarks. Analyze industry trends to understand the shifts and adapt your customer satisfaction strategies accordingly. Communicate with customers about the improvements and innovations you're making to align with higher standards and enhance their experience.",
      messgetime: "13 hours ago",
      messageStatus:'readstatus',
    },  
  ];

  exports.churnPredictionAlertList = [
    {
      id: 1,
      icons: 'highRisk',
      title: "High Churn Risk Customers",
      message:'High-risk customers show behavior indicative of churn.',
      description:"High-risk customers are showing behaviors indicative of potential churn.",
      suggestion:"Utilize predictive analytics to identify specific behaviors and patterns associated with high churn risk. Develop and deploy personalized retention strategies, such as targeted offers or loyalty programs, to re-engage these customers. Monitor their responses and adjust strategies as needed to reduce churn probability.",
      messgetime: "8 hours ago",
      messageStatus:'unreadstatus',
    },
    {
      id: 2,
      icons: 'negative',
      message:'Decline in usage patterns detected among high-risk customers.',
      title: "Usage Decline", 
      description: "A decline in usage patterns has been detected among high-risk customers, indicating potential disengagement.",
      suggestion:"Conduct a detailed usage analysis to understand the root causes of declining engagement. Implement re-engagement campaigns, such as personalized content or usage tips, to encourage more frequent use. Offer incentives or exclusive features to high-risk customers to boost their engagement levels.",
      messgetime: "23 hours ago",
      messageStatus:'unreadstatus',
    }, 
    {
      id: 3,
      icons: 'highValue',
      message:'High-value customers are exhibiting a notable decrease in product usage.',
      title: "Usage Drop among High-Value Customers", 
      description: "High-value customers are exhibiting a notable decrease in product usage, risking significant revenue loss.",
      suggestion:"Perform a comprehensive analysis to identify why high-value customers are reducing their usage. Reach out to these customers directly to gather feedback and address their concerns promptly. Enhance the value proposition for high-value customers by offering premium support, exclusive features, or customized solutions to retain their loyalty and increase usage.",
      messgetime: "23 hours ago",
      messageStatus:'readstatus',
    },  
  ];